import { providerList } from '@blax-modules/base-front-end/resources/js/utilities/providers'

import { Video } from './video.js';
providerList.instantiate('Video', Video);